export const ADMIN_QUERY_TTL = 60_000;

interface Entry {
	value?: unknown;
	updatedAt: number;
	pending?: Promise<unknown>;
}
export class AdminQueryCache {
	private entries = new Map<string, Entry>();
	private generation = 0;
	async get<T>(key: string, fetcher: () => Promise<T>, force = false, now = Date.now()): Promise<T> {
		const entry = this.entries.get(key);
		if (entry?.pending) return entry.pending as Promise<T>;
		if (!force && entry && entry.updatedAt && now - entry.updatedAt < ADMIN_QUERY_TTL)
			return entry.value as T;
		const generation = this.generation;
		const next: Entry = { updatedAt: entry?.updatedAt || 0, value: entry?.value };
		const work = fetcher()
			.then((value) => {
				if (generation === this.generation) {
					next.value = value;
					next.updatedAt = Date.now();
				}
				return value;
			})
			.finally(() => {
				next.pending = undefined;
			});
		next.pending = work;
		if (this.entries.size >= 200) this.entries.delete(this.entries.keys().next().value!);
		this.entries.set(key, next);
		return work;
	}
	clear() {
		this.generation++;
		this.entries.clear();
	}
}

export const adminQueryCache = new AdminQueryCache();
const listeners = new Set<() => void>();
export function invalidateAdminQueries() {
	adminQueryCache.clear();
	for (const listener of listeners) listener();
}
export function subscribeAdminInvalidation(listener: () => void) {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}
